(function(){
  var root = document.querySelector('[data-gpp]');
  if(!root || root.dataset.init) return; root.dataset.init = '1';
  var $ = function(s,c){ return (c||root).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||root).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header height */
  function setGH(){ var h = document.querySelector('.section-header, sticky-header, header.header'); var v = h ? Math.round(h.getBoundingClientRect().height) : 0; root.style.setProperty('--gh', v + 'px'); return v; }
  setGH(); window.addEventListener('resize', setGH);

  /* reveals */
  var rv = $$('.gp-rv');
  if('IntersectionObserver' in window && !reduce){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin:'0px 0px -8% 0px' });
    rv.forEach(function(el,i){ el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
  } else { rv.forEach(function(el){ el.classList.add('is-in'); }); }

  /* ---------- gallery ---------- */
  var track = $('[data-gpp-track]'), slides = $$('.gpp-slide'), thumbs = $$('[data-gpp-thumb]'), cur = $('[data-gpp-cur]');
  var index = 0;
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function setActive(i){
    index = i;
    thumbs.forEach(function(t,j){ t.classList.toggle('is-active', j === i); });
    if(cur) cur.textContent = pad(i + 1);
    var t = thumbs[i]; if(t && t.scrollIntoView && t.parentElement.scrollHeight > t.parentElement.clientHeight + 4){ t.parentElement.scrollTo({ top: t.offsetTop - 20, behavior:'smooth' }); }
  }
  function go(i){ if(!track || !slides.length) return; i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); setActive(i); }
  if(track){
    var st; track.addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(function(){ var i = Math.round(track.scrollLeft / track.clientWidth); if(i !== index) setActive(i); }, 60); }, { passive:true });
  }
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(Number(t.dataset.gppThumb)); }); });
  var prev = $('[data-gpp-prev]'), next = $('[data-gpp-next]');
  prev && prev.addEventListener('click', function(){ go(index - 1); });
  next && next.addEventListener('click', function(){ go(index + 1); });
  /* hover zoom */
  if(window.matchMedia('(hover:hover) and (pointer:fine)').matches){
    slides.forEach(function(s){
      var img = s.querySelector('img'); if(!img) return;
      s.addEventListener('click', function(){ s.classList.toggle('is-zoom'); if(!s.classList.contains('is-zoom')) img.style.transformOrigin = ''; });
      s.addEventListener('mousemove', function(e){ if(!s.classList.contains('is-zoom')) return; var r = s.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; });
      s.addEventListener('mouseleave', function(){ s.classList.remove('is-zoom'); });
    });
  }

  /* ---------- variants ---------- */
  var variants = []; try{ variants = JSON.parse($('[data-gpp-variants]').textContent); }catch(e){}
  var idInput = $('[data-gpp-id]'), atc = $('[data-gpp-atc]'), atcLabel = $('[data-gpp-atc-label]'), atcPrice = $('[data-gpp-atc-price]');
  var priceEl = $('[data-gpp-price]'), wasEl = $('[data-gpp-was]'), saveEl = $('[data-gpp-save]'), flag = $('[data-gpp-flag]');
  var stickyPrice = $('[data-gpp-sticky-price]'), stickyBtn = $('[data-gpp-sticky-btn]');
  var opts = $$('[data-gpp-opt]');
  var qtyIn = $('[data-gpp-qtyin]');
  var current = variants.filter(function(v){ return idInput && v.id === Number(idInput.value); })[0] || variants[0];

  function selected(){ return opts.map(function(f){ var a = f.querySelector('.gpp-pill.is-active'); return a ? a.dataset.value : null; }); }
  function find(sel){ return variants.filter(function(v){ return v.options.every(function(o,i){ return o === sel[i]; }); })[0]; }
  function markAvailability(){
    var sel = selected();
    opts.forEach(function(f,oi){
      $$('.gpp-pill', f).forEach(function(p){
        var test = sel.slice(); test[oi] = p.dataset.value;
        var v = find(test); p.classList.toggle('is-na', !v || !v.available);
      });
    });
  }
  function render(v){
    if(!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; atcPrice.textContent = ''; return; }
    current = v; idInput.value = v.id;
    priceEl.textContent = v.price_f;
    var onSale = v.cap > v.price;
    wasEl.hidden = !onSale; if(onSale) wasEl.textContent = v.cap_f;
    saveEl.hidden = !onSale; if(onSale) saveEl.textContent = 'Save ' + v.save_f;
    if(flag){ flag.hidden = !onSale; if(onSale) flag.textContent = 'Save ' + v.save_f; }
    atc.disabled = !v.available; atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out'; atcPrice.textContent = v.available ? v.price_f : '';
    if(stickyPrice) stickyPrice.textContent = v.price_f;
    if(stickyBtn){ stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    $$('form[action*="/cart/add"] input[name="id"]', document).forEach(function(i){ if(root.contains(i)) i.value = v.id; });
    if(v.media){ var si = slides.findIndex ? slides.findIndex(function(s){ return Number(s.dataset.mediaId) === v.media; }) : -1; if(si > -1) go(si); }
    if(history.replaceState){ var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    updateShipping();
  }
  opts.forEach(function(f){
    $$('.gpp-pill', f).forEach(function(p){
      p.addEventListener('click', function(){
        $$('.gpp-pill', f).forEach(function(x){ x.classList.remove('is-active'); x.setAttribute('aria-pressed','false'); });
        p.classList.add('is-active'); p.setAttribute('aria-pressed','true');
        var lab = f.querySelector('[data-gpp-optval]'); if(lab) lab.textContent = p.dataset.value;
        render(find(selected())); markAvailability();
      });
    });
  });
  if(opts.length) markAvailability();

  /* quantity */
  $$('[data-gpp-qty]').forEach(function(b){
    b.addEventListener('click', function(){ var n = Math.max(1, (parseInt(qtyIn.value,10) || 1) + Number(b.dataset.gppQty)); qtyIn.value = n; updateShipping(); });
  });
  qtyIn && qtyIn.addEventListener('change', function(){ qtyIn.value = Math.max(1, parseInt(qtyIn.value,10) || 1); updateShipping(); });

  /* ---------- shipping meter + ETA ---------- */
  var fs = Number(root.dataset.fs) || 0, cartTotal = Number(root.dataset.cartTotal) || 0;
  var fsText = $('[data-gpp-fs-text]'), fsBar = $('[data-gpp-fs-bar]'), fsRow = $('[data-gpp-fs]');
  function money(c){ return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function updateShipping(){
    if(!fs || !fsText) return;
    var add = current ? current.price * (parseInt(qtyIn && qtyIn.value,10) || 1) : 0;
    var total = cartTotal + add, left = fs - total;
    if(left <= 0){ fsText.innerHTML = 'This order ships <b>free</b>'; fsRow.classList.add('is-free'); fsBar.style.width = '100%'; }
    else { fsText.innerHTML = 'Add <b>' + money(left) + '</b> more for free shipping'; fsRow.classList.remove('is-free'); fsBar.style.width = Math.min(100, total / fs * 100) + '%'; }
  }
  updateShipping();
  var eta = $('[data-gpp-eta]');
  if(eta){
    var mn = Number(root.dataset.shipMin) || 5, mx = Number(root.dataset.shipMax) || 15;
    var f = function(d){ return d.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric' }); };
    var a = new Date(), b = new Date(); a.setDate(a.getDate() + mn); b.setDate(b.getDate() + mx);
    eta.textContent = f(a) + ' – ' + f(b);
  }

  /* ---------- cart ---------- */
  var toast = $('[data-gp-toast]'), toastT;
  function showToast(msg){ if(!toast) return; $('[data-gp-toast-text]').textContent = msg; toast.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function(){ toast.classList.remove('is-on'); }, 3200); }
  function addToCart(id, qty, btn){
    if(btn) btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: Number(id), quantity: qty || 1 }] };
    if(drawer && drawer.getSectionsToRender){ body.sections = drawer.getSectionsToRender().map(function(s){ return s.id; }); body.sections_url = window.location.pathname; }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(btn) btn.classList.remove('is-loading');
        if(res.status){ showToast(res.description || 'Could not add to cart'); return; }
        var item = res.items ? res.items[0] : res;
        cartTotal += item.final_line_price || 0; updateShipping();
        try{
          if(drawer && drawer.renderContents){ drawer.classList.remove('is-empty'); drawer.renderContents(Object.assign({}, item, { sections: res.sections, id: item.id })); return; }
        }catch(e){}
        showToast('Added — ' + (item.product_title || 'to cart'));
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ $$('.cart-count-bubble span[aria-hidden]', document).forEach(function(s){ s.textContent = c.item_count; }); }).catch(function(){});
      })
      .catch(function(){ if(btn) btn.classList.remove('is-loading'); showToast('Something went wrong — try again'); });
  }
  var form = document.getElementById('gpp-form');
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault(); if(!current || !current.available) return;
      addToCart(current.id, parseInt(qtyIn.value,10) || 1, atc);
    });
  }
  stickyBtn && stickyBtn.addEventListener('click', function(){ if(current && current.available) addToCart(current.id, parseInt(qtyIn.value,10) || 1, stickyBtn); });
  $$('[data-gpp-quick]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); addToCart(b.dataset.gppQuick, 1, b); }); });

  /* scroll-to-buy links */
  $$('[data-gpp-totop]').forEach(function(a){ a.addEventListener('click', function(e){ e.preventDefault(); var t = document.getElementById('gpp-form'); if(t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - setGH() - 120, behavior: reduce ? 'auto' : 'smooth' }); }); });

  /* ---------- sticky ATC ---------- */
  var sticky = $('[data-gpp-sticky]');
  if(sticky && atc && 'IntersectionObserver' in window){
    var footer = document.querySelector('footer, .footer, .shopify-section-group-footer-group');
    var atcVisible = true, footVisible = false;
    function upd(){ var on = !atcVisible && !footVisible; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); if(stickyBtn) stickyBtn.tabIndex = on ? 0 : -1; }
    new IntersectionObserver(function(es){ atcVisible = es[0].isIntersecting || es[0].boundingClientRect.top > 0; upd(); }).observe(atc);
    if(footer) new IntersectionObserver(function(es){ footVisible = es[0].isIntersecting; upd(); }).observe(footer);
  }
})();
